"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:7.3.0'] && _();
}
catch (e) { }
